var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMintActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9736 2.4873C12.1429 2.57251 12.3638 2.68753 12.6201 2.83594C13.2519 3.20173 14.0921 3.7554 14.9287 4.50391C16.6073 6.0058 18.1953 8.21908 18.1953 11.2422C18.1953 13.5427 16.649 15.7573 14.8916 17.498C14.035 18.3466 13.1741 19.0372 12.5264 19.5156C12.3265 19.6632 12.1472 19.7891 11.9961 19.8936C11.845 19.7891 11.6656 19.6632 11.4658 19.5156C10.8181 19.0372 9.95723 18.3466 9.10059 17.498C7.34324 15.7573 5.79688 13.5427 5.79688 11.2422C5.79688 8.01911 7.39562 5.81043 9.05176 4.37207C9.88199 3.65108 10.7161 3.13415 11.3428 2.79883C11.5921 2.66541 11.8075 2.56317 11.9736 2.4873Z",
    stroke: "#059669",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6094L12.0017 8.21094",
    stroke: "#059669",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintActivity);
export default __webpack_public_path__ + "static/media/mint-activity.b0fec50cdf11c9cc9b5d9d5ed1a7f3df.svg";
export { ForwardRef as ReactComponent };